import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppModalAction, ErrorModal } from "../../Generic/AppModal/AppModal";

interface Props {
  isLoading?: boolean;
  error?: string;
  onRequestClose: () => void;
}

const InvalidPinModal = (props: Props) => {
  const actions: AppModalAction[] = React.useMemo(
    () => [
      {
        key: "try_again",
        variant: "soft",
        color: "danger",
        children: translate(STRINGS.TRY_AGAIN),
        onClick: props.onRequestClose,
      },
    ],
    [props.onRequestClose]
  );

  return (
    <ErrorModal
      title={translate(STRINGS.OOPS) + "!"}
      message={props.error}
      isOpen={props.error !== undefined}
      isLoading={props.isLoading}
      actions={actions}
      onRequestClose={props.onRequestClose}
    />
  );
};

export default React.memo(InvalidPinModal);
